import {
  OeDefaultTheme,
  secondaryFontFamily,
  styled,
  ThemeProvider,
} from '@openeducation/oe-rn-themes';
import { Picker } from '@react-native-picker/picker';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Platform } from 'react-native';
import { Modal, Portal } from 'react-native-paper';

import { OEButton, OEText } from '../../atoms';
import { flex } from '../../style-utils';
import type { PickerItem } from './input-picker';

interface ModalPickerContentProps {
  items: PickerItem[];
  onChange: (value: string) => void;
  visible: boolean;
  onClose: () => void;
  title?: string;
  value?: string;
  mode?: 'dialog' | 'dropdown';
}

export function ModalPickerContent({
  items,
  onChange,
  title,
  value = '',
  onClose,
  visible,
  mode,
}: ModalPickerContentProps) {
  const { t } = useTranslation();
  const [selectedValue, setSelectedValue] = useState(value);

  useEffect(() => {
    setSelectedValue(value);
  }, [value]);

  return (
    <Portal>
      <ThemeProvider theme={OeDefaultTheme}>
        <Modal visible={visible} onDismiss={onClose}>
          <Container isIOS={Platform.OS === 'ios'}>
            <Title>{title}</Title>
            <Picker
              selectedValue={selectedValue}
              onValueChange={(itemValue) => setSelectedValue(itemValue)}
              style={flex('flex-1')}
              itemStyle={flex('flex-1')}
              mode={mode}
            >
              {items.map((item, i) => (
                <Picker.Item key={i} value={item.value} label={item.title} />
              ))}
            </Picker>
            <OEButton onPress={() => onChange(selectedValue)}>
              {t('okCaption')}
            </OEButton>
          </Container>
        </Modal>
      </ThemeProvider>
    </Portal>
  );
}

interface ContainerProps {
  isIOS: boolean;
}

const Container = styled.View<ContainerProps>`
  height: ${({ isIOS }) => (isIOS ? '80%' : '45%')};
  background-color: ${({ theme }) => theme.color.background};
  padding: 10px 20px;
  border-radius: 10px;
  margin: 0 10px;
`;

const Title = styled(OEText).attrs({
  fontType: 'bold',
  fontFamily: secondaryFontFamily,
})`
  font-size: 24px;
  line-height: 30px;
`;
